import { Flo } from '../../types/flo-continue-watching-api'
import { getAuthToken } from '../../utils/authentication'
import { floFetch, getContinueWatchingApiUrL } from '../../utils/network'

export class FloContinueWatching {
  protected BASE_URL = getContinueWatchingApiUrL()

  public async saveProgress(reqParams: Flo.ContinueWatching.SaveProgressRequest): Promise<void> {
    try {
      await floFetch(`${this.BASE_URL}/save-progress`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reqParams),
      })
    } catch (error) {
      console.error(error)
    }
  }
}
